import { create } from 'zustand';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://vclass.vskul.com/api';

export const useRoomStore = create((set) => ({
  rooms: [],
  isLoading: false,
  error: null,

  getRooms: async (type = 'all') => {
    set({ isLoading: true, error: null });
    try {
      const response = await axios.get(`${API_URL}/rooms?type=${type}`);
      set({
        rooms: response.data.rooms || [],
        isLoading: false,
      });
      return response.data.rooms;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to fetch rooms';
      set({ error: message, isLoading: false });
      throw error;
    }
  },

  createRoom: async (roomData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/rooms`, roomData);
      const newRoom = response.data.room;
      set((state) => ({
        rooms: [...state.rooms, newRoom],
        isLoading: false,
      }));
      return newRoom;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to create room';
      set({ error: message, isLoading: false });
      throw error;
    }
  },

  setError: (error) => set({ error }),
}));
